import { createAction, props } from "@ngrx/store";
import { Address } from "clicklease-ui-elements";

export const updateEquipmentLocationData = createAction(
    `[Equipment Location Form] update Equipment Location Data`,
    props<{ locationData: Address }>()
);

export const updateEquipmentLocationDataSuccess = createAction(
    `[Equipment Location Form] update Equipment Location Data Success`,
);

export const updateEquipmentLocationDataError = createAction(
    `[Equipment Location Form] update Equipment Location Data Error`,
    props<{ error: string }>()
);

export const resetSubmittingEquipmentLocationForm = createAction(
    `[Equipment Location Form] reset Equipment Location Form Data`,
);